import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_SUCCESS,
  CREATE_ACCOUNT_SUCCESS
} from "./types";

import AuthService from "../services/auth.service";

export const login = (username, password) => (dispatch) => {
  return AuthService.login(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message = "Login failed";

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const forgotpassword = (email) => (dispatch) => {
  return AuthService.forgotpassword(email).then(
    (data) => {
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS
      });

      return Promise.resolve();
    },
    (error) => {
      const message = "An error has occurred";

      dispatch({
        type: FORGOT_PASSWORD_FAILED,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const createAccount = (first_name, last_name, email, password) => (dispatch) => {
  return AuthService.createAccount(first_name, last_name, email, password).then(
    (data) => {
      dispatch({
        type: CREATE_ACCOUNT_SUCCESS
      });
      return Promise.resolve();
    },
    (error) => {
      return Promise.reject();
    }
  );
};

export const updateCurrentUser = (newUser) => (dispatch) => {
  localStorage.setItem("user", JSON.stringify(newUser));
  dispatch({
    type: LOGIN_SUCCESS,
    payload: { user: newUser },
  });
}

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};